import { FiLink } from 'react-icons/fi';

import Input from '@components/Input';

import { FieldRendererProps } from '../types';

const UrlField = ({ field, disabled }: FieldRendererProps) => (
  <Input
    name={field.name}
    type="url"
    placeholder={field.placeholder || field.label}
    icon={FiLink}
    disabled={disabled}
    required={field.is_required}
    inputMode="url"
  />
);

export default UrlField;
